module.exports = __webpack_public_path__ + "assets/img/1.2d752105.png";